import { ReferenceField } from "@/components/admin";
import type { Identifier } from "ra-core";
import { useGetRecordRepresentation, useTranslate } from "ra-core";
import { EditSheet } from "../misc/EditSheet";
import { TaskFormContent } from "./TaskFormContent";
import { TaskHistory } from "./TaskHistory";

export interface TaskEditSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  taskId: Identifier;
}

export const TaskEditSheet = ({
  open,
  onOpenChange,
  taskId,
}: TaskEditSheetProps) => {
  const translate = useTranslate();
  const getContactRepresentation = useGetRecordRepresentation("contacts");
  return (
    <EditSheet
      resource="tasks"
      id={taskId}
      title={
        <ReferenceField
          source="contact_id"
          // A task about an account or a deal names no person, so the sheet
          // falls back to the generic title rather than showing none.
          empty={
            <span className="text-xl font-semibold truncate pr-10">
              {translate("resources.tasks.sheet.edit")}
            </span>
          }
          reference="contacts"
          render={({ referenceRecord }) => (
            <span className="text-xl font-semibold truncate pr-10">
              {referenceRecord
                ? translate("resources.tasks.sheet.edit_for", {
                    name: getContactRepresentation(referenceRecord),
                  })
                : translate("resources.tasks.sheet.edit")}
            </span>
          )}
        />
      }
      redirect={false}
      open={open}
      onOpenChange={onOpenChange}
    >
      {/* Nothing on this sheet implies a target, so the user picks one. */}
      <TaskFormContent selectContact />
      <TaskHistory taskId={taskId} />
    </EditSheet>
  );
};
